import { Field, Form, useFormikContext } from 'formik';
import { FormikCheckboxInput } from '@forms/Components/CheckInput';
import { FormikDateTimeRangeInput } from '@forms/Components/DateTimeRangeInput';
import { UpdateScheduledPuDlFormik } from './types';

import styles from './FormikForm.module.css';

interface FormikFormProps {
	id: string;
}

/**
 * Update Scheduled Pickup and Delivery Date and Time Form
 */
export default function FormikForm({ id }: FormikFormProps) {
	const { values } = useFormikContext<UpdateScheduledPuDlFormik>();
	return (
		<Form
			className={styles.form}
			id={id}
		>
			<div className={styles['flex-row']}>
				<div className={styles.container}>
					<fieldset className={styles.fieldset}>
						<legend className={styles.legend}>Pickup</legend>
						<div className={styles['flex-row']}>
							<Field
								name='scheduledPickupDateRange'
								component={FormikDateTimeRangeInput}
								label='Scheduled'
								className={styles['date-time-input']}
								disabled={values.removeScheduledPickup}
							/>
						</div>
						<div className={styles['flex-row']}>
							<Field
								name={'removeScheduledPickup'}
								component={FormikCheckboxInput}
								label='Remove Scheduled Pickup Date & Time from selected record(s)'
								labelPlacement='start'
							/>
						</div>
					</fieldset>

					<fieldset className={styles.fieldset}>
						<legend className={styles.legend}>Delivery</legend>
						<div className={styles['flex-row']}>
							<Field
								name='scheduledDeliveryDateRange'
								component={FormikDateTimeRangeInput}
								label='Scheduled'
								className={styles['date-time-input']}
								disabled={values.removeScheduledDelivery}
							/>
						</div>
						<div className={styles['flex-row']}>
							<Field
								name={'removeScheduledDelivery'}
								component={FormikCheckboxInput}
								label='Remove Scheduled Delivery Date & Time from selected record(s)'
								labelPlacement='start'
							/>
						</div>
					</fieldset>
				</div>
			</div>
		</Form>
	);
}
